import { API_BASE_URL } from '../api/axios';
import { getAuthToken, logoutSession } from './authStorage';

const PUBLIC_API_PATHS = [
  '/login',
  '/sendpasswordlink',
  '/ResetPasswordpage/',
  '/Changepassword/',
];

const isPublicApiUrl = (url) => PUBLIC_API_PATHS.some((path) => url.includes(path));

const setupAuthenticatedFetch = () => {
  if (typeof window === 'undefined' || window.__hrAuthFetchPatched) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const requestUrl = typeof input === 'string' ? input : input?.url || '';

    if (!requestUrl.startsWith(API_BASE_URL) || isPublicApiUrl(requestUrl)) {
      return originalFetch(input, init);
    }

    const token = getAuthToken();
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));

    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    const response = await originalFetch(input, { ...init, headers });

    if (response.status === 401 && !isPublicApiUrl(requestUrl)) {
      logoutSession();
    }

    return response;
  };

  window.__hrAuthFetchPatched = true;
};

export default setupAuthenticatedFetch;
